module.exports = __webpack_public_path__ + "342dea309dfd36ab9d9edacb4a2cb81b.png";